/**
 * Copy controller - handles copying prompt text to clipboard
 */

import { recordCopy } from '../../../../shared/data/promptsRepo';

/**
 * Copy text to clipboard
 * @param {string} text - The text to copy
 * @returns {Promise<boolean>} True if successful
 */
export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        document.body.removeChild(textArea);
        return true;
      } catch (err) {
        document.body.removeChild(textArea);
        return false;
      }
    }
  } catch (err) {
    console.error('Failed to copy text:', err);
    return false;
  }
};

/**
 * Copy prompt text to clipboard and track copy count
 * @param {string} promptText - The prompt text to copy
 * @param {string} promptId - Optional prompt ID for tracking
 * @param {string} orgId - Optional organization ID for tracking
 * @returns {Promise<boolean>} True if successful
 */
export const copyPrompt = async (promptText, promptId = null, orgId = null) => {
  try {
    // Copy to clipboard first
    const success = await copyToClipboard(promptText);
    
    // Track copy count if promptId is provided
    if (success && promptId) {
      // Fire and forget - copy tracking is not critical
      recordCopy(promptId).catch(err => {
        console.warn('Failed to track copy count:', err);
      });
    }
    
    return success;
  } catch (err) {
    console.error('Failed to copy prompt:', err);
    return false;
  }
};

